import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upperCaseFirst'
})
export class UpperCaseFirstPipe implements PipeTransform {

    transform(value: string): any {
        return value ? value.slice(0, 1)
            .toUpperCase() + value.slice(1) : ''
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pipes/ucfirst/ucfirst.pipe.ts